/**
 * @flow
 * @relayHash 7c0dbafee9537114ee5d02ff37984219
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ItemSortField = "BOM_NUMBER" | "CREATED_AT" | "ITEM_NUMBER" | "NAME" | "PART_NUMBER" | "UPDATED_AT";
export type SortDirection = "ASC" | "DESC";
export type ItemSort = {|
  field: ItemSortField,
  direction: SortDirection,
|};
export type SelectItemFieldQueryVariables = {|
  sortBy?: ?ItemSort,
  search?: ?string,
  orderIds?: ?$ReadOnlyArray<string>,
|};
export type SelectItemFieldQueryResponse = {|
  +items: {|
    +edges: ?$ReadOnlyArray<?{|
      +node: {|
        +id: string,
        +name: string,
        +cost: ?number,
        +sellingPrice: ?number,
        +quantityUOM: {|
          +id: string,
          +name: string,
          +symbol: string,
        |},
      |}
    |}>
  |}
|};
export type SelectItemFieldQuery = {|
  variables: SelectItemFieldQueryVariables,
  response: SelectItemFieldQueryResponse,
|};
*/


/*
query SelectItemFieldQuery(
  $sortBy: ItemSort
  $search: String
  $orderIds: [ID!]
) {
  items(first: 300, sortBy: $sortBy, search: $search, orderIds: $orderIds) {
    edges {
      node {
        id
        name
        cost
        sellingPrice
        quantityUOM {
          id
          name
          symbol
        }
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "sortBy",
    "type": "ItemSort",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "search",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "orderIds",
    "type": "[ID!]",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v3 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "items",
    "storageKey": null,
    "args": [
      {
        "kind": "Literal",
        "name": "first",
        "value": 300
      },
      {
        "kind": "Variable",
        "name": "orderIds",
        "variableName": "orderIds"
      },
      {
        "kind": "Variable",
        "name": "search",
        "variableName": "search"
      },
      {
        "kind": "Variable",
        "name": "sortBy",
        "variableName": "sortBy"
      }
    ],
    "concreteType": "ItemConnection",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "ItemEdge",
        "plural": true,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "Item",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "cost",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "sellingPrice",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "quantityUOM",
                "storageKey": null,
                "args": null,
                "concreteType": "UOM",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  (v2/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "symbol",
                    "args": null,
                    "storageKey": null
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "SelectItemFieldQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v3/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "SelectItemFieldQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v3/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "SelectItemFieldQuery",
    "id": null,
    "text": "query SelectItemFieldQuery(\n  $sortBy: ItemSort\n  $search: String\n  $orderIds: [ID!]\n) {\n  items(first: 300, sortBy: $sortBy, search: $search, orderIds: $orderIds) {\n    edges {\n      node {\n        id\n        name\n        cost\n        sellingPrice\n        quantityUOM {\n          id\n          name\n          symbol\n        }\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '0ee579ab03f13eac477385cc7563567c';
module.exports = node;
